module.exports = __webpack_public_path__ + "img/icon-choice.ea4403af.svg";